import { render } from "./CoBrandForge.vue?vue&type=template&id=35656210&scoped=true"
import script from "./CoBrandForge.vue?vue&type=script&lang=js"
export * from "./CoBrandForge.vue?vue&type=script&lang=js"

import "./CoBrandForge.vue?vue&type=style&index=0&id=35656210&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35656210"]])

export default __exports__